import 'system/public-path';
import coreInterface from 'system/coreInterface';
import Application from 'system/components/Application';
// Page routes.
import { getPages } from './pages';

export default coreInterface(Application({ getPages, isUnregistered: true }));
